import { createFileRoute } from "@tanstack/react-router";
import EsServicePage from "@/pages/es/EsServicePage";
import { esTmsPtsd } from "@/pages/es/esServiceData";
import { SITE_URL, buildHreflang } from "@/lib/i18n/locale";

const ES_URL = `${SITE_URL}/es/services/ptsd`;

export const Route = createFileRoute("/es/services/ptsd")({
  head: () => ({
    meta: [
      { title: "TMS para el TEPT | Neuro Wellness TMS" },
      {
        name: "description",
        content:
          "TMS para el trastorno de estrés postraumático en Coral Springs, FL. Estimulación magnética no invasiva cuando los tratamientos convencionales no son.",
      },
      {
        property: "og:title",
        content: "TMS para el TEPT | Neuro Wellness TMS",
      },
      {
        property: "og:description",
        content: "Terapia TMS no invasiva para el TEPT en Coral Springs, FL.",
      },
      { property: "og:url", content: ES_URL },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: "es_ES" },
      { name: "twitter:card", content: "summary_large_image" },
      {
        name: "twitter:title",
        content: "TMS para el TEPT | Neuro Wellness TMS",
      },
      {
        name: "twitter:description",
        content: "Terapia TMS no invasiva para el TEPT en Coral Springs, FL.",
      },
    ],
    links: [
      { rel: "canonical", href: ES_URL },
      ...buildHreflang("/services/ptsd"),
    ],
  }),
  component: () => <EsServicePage cfg={esTmsPtsd} />,
});
